module.exports = __webpack_public_path__ + "img/saishianpai-icon-0.691cedec.png";